import React, { useEffect, useRef, useState } from 'react';
import { LogOut, PenLine, Settings } from 'lucide-react';
import UserAvatar from '@/components/ipe/UserAvatar';
import '@/styles/ipe/ipe-account-center.css';

export default function TutorialUserMenu({
  user,
  isEditor,
  isManager,
  editorApplyStatus,
  canApplyEditor,
  applyLabel,
  onOpenProfile,
  onOpenApply,
  onLogout,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const rootRef = useRef(null);
  const closeTimerRef = useRef(null);

  const roleLabel = isManager ? '管理' : isEditor ? '编辑' : editorApplyStatus === 'PENDING' ? '审核中' : '只读';

  const openMenu = () => {
    if (closeTimerRef.current) {
      window.clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setMenuOpen(true);
  };

  const scheduleClose = () => {
    if (closeTimerRef.current) window.clearTimeout(closeTimerRef.current);
    closeTimerRef.current = window.setTimeout(() => setMenuOpen(false), 180);
  };

  useEffect(() => () => {
    if (closeTimerRef.current) window.clearTimeout(closeTimerRef.current);
  }, []);

  const handleAction = (action) => {
    setMenuOpen(false);
    action?.();
  };

  return (
    <div className="tutorial-user-menu" ref={rootRef}>
      <button
        type="button"
        className="tutorial-user-menu__trigger"
        aria-expanded={menuOpen}
        aria-haspopup="menu"
        onMouseEnter={openMenu}
        onMouseLeave={scheduleClose}
        onClick={() => setMenuOpen((prev) => !prev)}
      >
        <UserAvatar
          avatarUrl={user?.avatarUrl}
          displayName={user?.username}
          className="tutorial-user-menu__avatar"
          size={34}
        />
        <span className="tutorial-user-menu__meta">
          <span className="tutorial-user-menu__name">{user?.username}</span>
          <em className="tutorial-user-menu__role">{roleLabel}</em>
        </span>
      </button>

      {menuOpen ? (
        <div
          className="tutorial-user-menu__dropdown"
          role="menu"
          onMouseEnter={openMenu}
          onMouseLeave={scheduleClose}
        >
          <div className="tutorial-user-menu__dropdown-head">
            <UserAvatar
              avatarUrl={user?.avatarUrl}
              displayName={user?.username}
              className="tutorial-user-menu__dropdown-avatar"
              size={40}
            />
            <div>
              <div className="tutorial-user-menu__dropdown-name">{user?.username}</div>
              <div className="tutorial-user-menu__dropdown-role">{roleLabel}</div>
            </div>
          </div>
          <div className="tutorial-user-menu__dropdown-divider" />
          <button
            type="button"
            className="tutorial-user-menu__item"
            role="menuitem"
            onClick={() => handleAction(onOpenProfile)}
          >
            <Settings size={16} />
            修改信息
          </button>
          {canApplyEditor ? (
            <button
              type="button"
              className="tutorial-user-menu__item"
              role="menuitem"
              onClick={() => handleAction(onOpenApply)}
            >
              <PenLine size={16} />
              {applyLabel}
            </button>
          ) : null}
          <button
            type="button"
            className="tutorial-user-menu__item tutorial-user-menu__item--danger"
            role="menuitem"
            onClick={() => handleAction(onLogout)}
          >
            <LogOut size={16} />
            退出
          </button>
        </div>
      ) : null}
    </div>
  );
}
